import { render } from "./qlc-q2.vue?vue&type=template&id=4c1afd8c&scoped=true"
import script from "./qlc-q2.vue?vue&type=script&lang=js"
export * from "./qlc-q2.vue?vue&type=script&lang=js"

import "./qlc-q2.vue?vue&type=style&index=0&id=4c1afd8c&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1afd8c"]])

export default __exports__